import { CompanyMapper } from './company.mapper';
import { DepartmentMapper } from './department.mapper';
import { IndustryMapper } from './industry.mapper';
import { WorkRecord } from './work-record.model';

export class WorkRecordMapper {
  public static map(workRecordData: any): WorkRecord {
    if (!workRecordData) {
      return null;
    }

    return new WorkRecord (
        CompanyMapper.map(workRecordData.company),
        IndustryMapper.map(workRecordData.industry),
        DepartmentMapper.map(workRecordData.department)
      );
    }
}



// WEBPACK FOOTER //
// /dist/src/app/user/work-record/work-record.mapper.ts